/** Official NM OCD facility IDs identify facilities, not well API numbers. */
export function isNmOcdFacilityId(value: unknown): boolean {
  return /^f[a-z]{2,}\d{4,}$/i.test(String(value ?? '').trim());
}

export interface ApiSearchIntent {
  raw: string;
  digits: string;
  canonicalDigits: string;
  formatted: string;
  state: 'NM' | 'TX';
}

export function parseApiSearchIntent(query: string | undefined, api: string | undefined): ApiSearchIntent | 'invalid' | null {
  const explicitApi = (api || '').trim();
  const raw = explicitApi || (query || '').trim();
  if (!raw || isNmOcdFacilityId(raw)) return null;

  const digits = raw.replace(/\D/g, '');
  const hasFullApiPrefix = digits.length >= 10 && (digits.startsWith('30') || digits.startsWith('42'));
  if (!explicitApi && !hasFullApiPrefix) return null;
  if (!hasFullApiPrefix) return 'invalid';

  const canonicalDigits = digits.slice(0, 10);
  const state = canonicalDigits.startsWith('30') ? 'NM' : 'TX';
  return {
    raw,
    digits,
    canonicalDigits,
    formatted: `${canonicalDigits.slice(0, 2)}-${canonicalDigits.slice(2, 5)}-${canonicalDigits.slice(5, 10)}`,
    state,
  };
}
